<template>
  <div>
    <div class="form-group date_range">
      <label v-if="title" for="">{{title}}</label>
      <div class="input-group">
        <datetime
          id="start_range"
          input-class="form-control"
          type="date"
          :minute-step="60"
          format="dd.MM.yyyy"
          :auto="true"
          v-model="range.start"></datetime>
        <div class="input-group-prepend input-group-append">
          <span class="input-group-text">по</span>
        </div>
        <datetime
          id="end_range"
          input-class="form-control"
          type="date"
          :minute-step="60"
          format="dd.MM.yyyy"
          :auto="true"
          v-model="range.end"></datetime>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {Datetime} from 'vue-datetime'

  export default {
    components: {
      Datetime,
    },
    props: {
      'title': {default: 'Период поиска'}
    },
    data() {
      return {
        range: {
          start: moment().subtract(3, 'month').toISOString(),
          end: null,
        }
      }
    }
  }

</script>
